import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  template: '<router-outlet></router-outlet>',
})
export class SimpleLayoutComponent { }



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/containers/simple-layout/simple-layout.component.ts